import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  actions: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  button: {
    padding: theme.spacing(0, 0.2),
  },
  item: {
    verticalAlign: 'bottom',
    padding: theme.spacing(0, 1),
  },
});
